<template>
  <v-chip
    class="requiredーchip text-center px-1 ma-0"
    x-small
    color="#ff8f00"
    text-color="white"
    label
  >
    {{ $t('common.input_required') }}
  </v-chip>
</template>
<script>
export default {
  name: 'RequiredLabel'
}
</script>

<style scoped>
.requiredーchip {
  line-height: 11px;
  margin-top: -1px !important;
}
</style>
